<template>
  <div class="down">
    <Header :isbig="true"></Header>
    <div class="downloadbox" style="border-top: 1px solid rgb(242, 245, 248);">
      <div class="right clearfix">
        <img class="fr" src="~img/account/downbg2.png" alt="" />
      </div>

      <div class="content clearfix">
        <img class="fl" src="~img/account/downbg1.png" alt="" />
        <div class="center">
          <img class="big" src="~img/account/download.png" alt="" />
          <img class="code" src="~img/account/cli_300px.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.down
    min-width  1400px
    background #fff
.downloadbox
    padding-top 30px
    .right
        margin-right 0
    .content
        height:286px;
        background:rgba(41,143,243,1);
        position relative
        min-width 1200px
        .fl
            position absolute
            left 0
            top 0
        .center
            width 912px
            margin 0 auto 0
            position relative
            .big
                width 912px
                margin-top -290px
            .code
                position absolute
                top 58px
                right 283px
                width 172px
                height 172px
</style>
